import { render, staticRenderFns } from "./authorizedAccount.vue?vue&type=template&id=1326d387&scoped=true"
import script from "./authorizedAccount.vue?vue&type=script&lang=js"
export * from "./authorizedAccount.vue?vue&type=script&lang=js"
import style0 from "./authorizedAccount.vue?vue&type=style&index=0&id=1326d387&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1326d387",
  null
  
)

export default component.exports